import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=4a0fa796"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a0fa796')) {
      api.createRecord('4a0fa796', component.options)
    } else {
      api.reload('4a0fa796', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=4a0fa796", function () {
      api.rerender('4a0fa796', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/orderProcessing/detail.vue"
export default component.exports